import {useEffect, useState} from 'react'

const RTL_LANGS = ['ar', 'he', 'fa', 'ur', 'yi']

function computeRtlProps() {
  if (typeof document === 'undefined') return {}
  const htmlLang = (document.documentElement.lang || '').split('-')[0].toLowerCase()
  if (!RTL_LANGS.includes(htmlLang)) return {}
  return {className: 'rtl', dir: 'rtl', lang: htmlLang}
}

export function useRtlProps() {
  const [props, setProps] = useState(computeRtlProps)

  useEffect(() => {
    const update = () => setProps(computeRtlProps())
    const observer = new MutationObserver(update)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
    })
    update()
    return () => observer.disconnect()
  }, [])

  return props
}
